var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
var SvgTraining = function (props) { return (_jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 33.088 26.824" }, props, { children: _jsx("path", { d: "m17.088 0 15.11 8.239.261-.14.015.291.614.335v11.5l-2 .052-.464-8.923-2.992 1.609v8.1l-10.544 5.761-10.545-5.755V12.89L0 9.321Zm13.007 9.373L17.088 2.278 4.176 9.321l2.366 1.291 1.479.8 9.067 4.951 10.545-5.754v.088Zm-13.479 9.011-8.074-4.4v5.9l8.546 4.661 8.545-4.663v-5.843l-8.069 4.339-.476.261Z" }) }))); };
export default SvgTraining;
